module.exports = __webpack_public_path__ + "static/media/facesheet@2x + copy to chart@2x Mask@3x.59ce93dc.png";